import styled, { css, keyframes } from 'styled-components';

// 消息-event块
export const MessageBody = styled.div`
  .message-appear {
    opacity: 0;
    transform: translateY(20px);
  }

  .message-appear-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 700ms, transform 700ms;
  }
`;

// 消息-event块
export const ChatMessageEvent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    // background: ${(props) => props.$chatservicecolor ?? '#F5EFF8'};
    text-align: center;
    color: #666666;
    padding: 4px 10px;
    box-sizing: border-box;
    border-radius: 5px;
    margin-bottom: 10px;
    font-size: ${(props) => (props.$device === 'pc' ? '14px' : '0.8rem')};
  }
`;
// 图片块内容
export const ContentImage = styled.div`
  border-radius: 8px 8px 8px 8px;
  display: inline-block;
  overflow: hidden;

  .ant-image-mask-info {
    font-size: 0;
  }
  .ant-image-mask-info span {
    // 再单独给span标签添加样式 让其显示并且给出文字大小
    visibility: visible;
    font-size: 20px;
  }

  img {
    border-radius: 3px 8px 8px 8px;
    width: 100%;
    height: 100%;
  }
`;
// 视频块内容
export const ContentVideo = styled.div`
  video {
    border-radius: 8px 8px 8px 8px;
    width: 100%;
    height: 100%;
  }
`;

const myAnimation = keyframes`
0% {
  transform: translateY(100%);
}
100% {
  transform: translateY(0);
}
`;
// 左边-坐席消息
export const ChatMessageAgentWrapper = styled.div`
  overflow: hidden;
  // animation: ${myAnimation} 0.5s ease-out;
  &:hover .messageTime {
    opacity: 1;
    transition: all 0.2s linear;
  }
`;
export const MessageQuote = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background: #eeeeee;
  display: inline-block;
  color: #666666;
  font-size: 10px;
  word-break: break-all;
`;
export const AgentInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  // height: 100%;
  svg {
    width: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    height: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    margin-right: 6px;
  }
  img {
    width: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    height: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    margin-right: 6px;
  }

  span {
    font-size: 16px;
    color: #333333;
  }
`;
export const AgentInfoMobile = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  justify-content: center;
  img {
    margin-right: 6px;
  }

  span {
    //font-size: 12px;
    font-size: 1rem;
    color: #333333;
  }
`;
export const AgentContentWrapper = styled.div`
  ${(props) =>
    props?.$device === 'pc'
      ? css`
          padding: 0 0 10px 32px;
          width: calc(100% - 32px - 26px);
        `
      : css`
          padding: 0 0 10px 40px;
          width: calc(90% - 40px - 26px);
        `}
`;
export const AgentContent = styled.span`
  background: ${(props) => props.$chatservicecolor ?? '#F5EFF8'};
  border-color: ${(props) => props.$chatmessagecolor ?? '#F5EFF8'};
  border-radius: 3px 8px 8px 8px;
  border-width: 1px;
  border-style: solid;
  padding: 4px 8px;
  box-sizing: border-box;
  color: ${(props) => props.$agentFontColor ?? '#333333'};
  font-size: ${(props) => (props.$device === 'pc' ? '14px' : '1rem')};
  display: inline-block;
  /* 这两个在技术上是一样的, 为了兼容了浏览器两个都加上 */
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

  img {
    width: 100%;
    height: auto;
  }

  * {
  }
  a {
    color: #409eff;
  }
  p {
    margin: 0;
  }
`;

// 相关推荐消息
export const AgentList = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  padding: ${(props) => (props.$device === 'pc' ? '0 0 7px 32px' : '0 0 7px 40px')};
`;
export const ListItem = styled.div`
  background: #f6f6f6;
  margin-right: 10px;
  margin-bottom: 5px;
  min-width: 10px;
  border-radius: 5px;
  color: #ffffff;
  font-size: ${(props) => (props.$device === 'pc' ? '12px' : '1rem')};
  padding: 4px 8px;
  cursor: pointer;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  text-align: left;
  &:hover {
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 1px solid ${(props) => props.$chatmessagecolor ?? '#AD30E5'};
    color: ${(props) => props.$chatmessagecolor ?? '#AD30E5'};
  }
`;

// 右边-客户消息
export const ChatMessageCustomerWrapper = styled.div`
  overflow: hidden;
`;
export const CustomerInfo = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 6px;

  img {
    max-width: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    min-width: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    max-height: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    min-height: ${(props) => (props.$device === 'pc' ? '24px' : '34px')};
    margin-left: 6px;
  }

  span {
    font-size: 16px;
    color: #333333;
  }
`;
// 用户侧
export const CustomerContentWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  box-sizing: border-box;
  ${(props) =>
    props?.$device === 'pc'
      ? css`
          padding: 0 0 10px 32px;
          width: calc(100% - 32px);
        `
      : css`
          display: flex;
          width: 100%;
          padding: 0 40px 0 56px;
        `}
`;
export const CustomerContent = styled.div`
  background: ${(props) => props.$chatmessagecolor ?? '#AD30E5'};
  border-color: ${(props) => props.$chatmessagecolor ?? '#AD30E5'};
  border-radius: 8px 3px 8px 8px;
  border-width: 1px;
  border-style: solid;
  padding: 4px 8px;
  box-sizing: border-box;
  margin-top: ${(props) => (props.$showEndCustomerName ? '0' : '-25px')};
  // width: calc(90% - 26px);
  color: ${(props) => props.$userFontColor ?? '#fff'};
  font-size: ${(props) => (props.$device === 'pc' ? '14px' : '1rem')};
  display: inline-block;
  /* 这两个在技术上是一样的, 为了兼容了浏览器两个都加上 */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  /* 如果浏览器支持的话增加一个连接符(Blink不支持) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  * {
  }

  a {
    color: #ffffff;
    text-decoration: underline;
  }

  p {
    margin: 0;
  }
`;
export const CustomerContentFooter = styled.div`
  font-size: 13px;
  color: #999999;
  margin-top: 5px;
`;

//满意度图标
export const EvaluationContainer = styled.div`
  img {
    margin-right: 8px;
  }
`;

//满意度图标
export const CustomerMessageWarpper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
//满意度评价分界线
export const EvaluationLine = styled.div`
  height: 1px;
  background: linear-gradient(to right, #fff 0%, #d9d9d9 30%, #d9d9d9 70%, #fff 100%);
  width: 100%;
  margin-bottom: 25px;
`;
//满意度评价
export const EvaluationDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const FileUploading = styled.div`
  text-align: right;
  font-size: 14px;
`;
export const UploadContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const LeftWrapper = styled.div`
  margin-right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background: ${(props) => props.$chatservicecolor ?? '#F5EFF8'};
  img {
    width: 15px;
    height: 15px;
  }
  &:hover {
    background: ${(props) => props.$themecolor ?? '#3F5773'};
  }
`;
export const RightWrapper = styled.div``;

export const LikeButContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  svg {
    cursor: pointer;
    width: 20px;
    height: 20px;
  }
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  :nth-child(2) {
    width: 1px;
    height: 15px;
    background-color: #e6e6e6;
    margin: 0 10px 0 10px;
  }
  :nth-child(3) {
    transform: rotate(180deg);
  }
`;

export const DIVIDER = styled.div`
  margin: 16px 0;
  width: 100%;
  height: 1px;
  background: #f0f0f0;
  span {
    margin: 0 10px;
  }
`;
